import {createApp} from '../../auth/src/main.js';

import App from '../../auth/src/LoginPage.vue';
createApp(App);